<h1 mat-dialog-title class="dialog-title">{{ data.name }}</h1>
<div mat-dialog-content class="dialog-content">
  <p>{{ data.name }} is an editable document. Please open it in a new tab to fill out and download your completed form.</p>
</div>
<div mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="onCancel()" class="cancel-button">Cancel</button>
  <button mat-raised-button (click)="onOpen()" class="open-button">Open Form</button>
</div>
